<template>
  <Row class="FormSection">
    <Column :md="4">
      <div class="sectionMeta">
        <h3>
          {{ sectionTemplate.name }}
        </h3>
        <div class="actions">
          <BtnApproval
            :approvedAt="section.approvedAt"
            :shouldApprove="section.shouldApprove"
            @update:approvedAt="$up('section.approvedAt', $event)" />
          <Btn
            class="ib sm inv noBorder"
            :disabled="section.position === sectionCount"
            @click="offsetPosition(2)">
            <Icon name="down" />
          </Btn>
          <Btn
            class="ib sm inv noBorder"
            :disabled="section.position < 2"
            @click="offsetPosition(-2)">
            <Icon name="up" />
          </Btn>
          <Btn
            class="ib sm danger inv noBorder"
            @click="$emit('remove')">
            <Icon name="cross" />
          </Btn>
        </div>
      </div>
      <FormArticleImage
        :article="article"
        :fileId="section.imageFileId"
        :imageDropId="uniqueKey"
        :section="section"
        type="ARTICLE_SECTION_IMAGE"
        @update:fileId="$up('section.imageFileId', $event)"
        @update:section="$up('section', $event)" />
      <FormValidation>
        <FormSectionFields
          :sectionFields="section.fields"
          :sectionTemplateFields="sectionTemplate.fields"
          @update:sectionFields="$up('section.fields', $event)" />
      </FormValidation>
      <FormLinksSelection
        :links="section.links"
        :text="textVariantFocused"
        @updateVariantFocused="updateVariantFocused" />
      <Field
        :label="$t('positionExport')"
        :options="positionExportOptions"
        type="select"
        :value="section.positionExport"
        @update:value="$up('section.positionExport', $event)" />
    </Column>
    <Column :md="8">
      <div v-if="sectionTemplate.hasTitle" class="sectionTitle">
        <Field
          :placeholder="$t('title')"
          :value.sync="section.title">
          <FieldBtn
            class="light"
            :isLoading="isGeneratingTitle"
            @click="generateTitle">
            {{ $t('suggest') }}
          </FieldBtn>
        </Field>
      </div>
      <FieldFillable
        ref="fieldFillable"
        :article="article"
        :filler="fillText"
        :imagePhrases.sync="section.imagePhrases"
        :placeholder="$t('text')"
        type="textarea"
        :variantIndex="section.textVariantIndex"
        :variants="section.textVariants"
        @update:links="section.links = $event"
        @update:variantIndex="$up('section.textVariantIndex', $event)"
        @update:variants="$up('section.textVariants', $event)">
        <FormResearch
          slot="research"
          :article="article"
          :facts="section.facts"
          :section="section"
          :sectionTemplate="sectionTemplate"
          @save="$emit('save')"
          @update:facts="$up('section.facts', $event)"
          @update:section="$up('section', $event)" />
      </FieldFillable>
      <!--
      <FormSectionChart
        v-if="specType.chartTemplate"
        :chart.sync="section.chart" />
      -->
    </Column>
  </Row>
</template>

<script>
import { actions, getters } from '@utils'
import BtnApproval from './BtnApproval'
import FieldFillable from '@forms/FieldFillable'
import FormArticleImage from '@forms/FormArticleImage'
// TODO: add back charts
// import FormSectionChart from '../FormSectionChart'
import FormLinksSelection from '@forms/FormLinksSelection'
import FormResearch from '@forms/FormArticle/FormResearch'
import FormSectionFields from './FormSectionFields'
import { randomElementId } from '@utils/strings'
import { update } from 'rambda'

export default {
  components: {
    // FormSectionChart,
    BtnApproval,
    FieldFillable,
    FormArticleImage,
    FormLinksSelection,
    FormResearch,
    FormSectionFields,
  },
  props: {
    article: Object,
    section: Object,
    sectionCount: Number,
  },
  data() {
    return {
      isGeneratingTitle: false,
      uniqueKey: `section${this.section.sectionTemplateId}Image-${randomElementId()}`,
    }
  },
  computed: {
    textVariantFocused() {
      const { textVariants, textVariantIndex } = this.section

      return textVariants[textVariantIndex]
    },
    sectionTemplate() {
      return this.queryOne('sectionTemplate', this.section.sectionTemplateId)
    },
    ...getters('positionExportOptions'),
  },
  methods: {
    fillText() {
      return this.CREATE_SECTION_COMPLETION(this.section)
    },
    updateVariantFocused(text) {
      const { textVariants, textVariantIndex } = this.section

      this.$up('section.textVariants', update(textVariantIndex, text, textVariants))
    },
    offsetPosition(offset) {
      this.$up('section.position', this.section.position + offset)
    },
    async generateTitle() {
      const { title } = await this.$wrap(
        () => this.CREATE_SECTION_TITLE({
          topic: this.article.topic,
          category: this.article.category,
          sectionTemplateName: this.sectionTemplate.name,
          sectionTemplateNameAlt: this.sectionTemplate.nameAlt,
        }),
        'isGeneratingTitle',
      )

      this.$up('section.title', title)
    },
    // async generateAlternativeText() {
    //   const { name } = await this
    //     .$wrap(() => this.CREATE_SECTION_IMAGE_ALT({
    //       topic: this.article.topic,
    //       sectionTemplateId: this.sectionTemplate.id,
    //     }))

    //   this.$up('section.imageAlt', name)
    // },
    ...actions(
      // 'CREATE_IMAGE_ALT',
      'CREATE_SECTION_COMPLETION',
      'CREATE_SECTION_TITLE',
    ),
  },
}
</script>

<style lang="scss">
.FormSection {
  border-bottom: 1px dashed $border-color;
  margin-bottom: $grid-unit;
  padding-bottom: $grid-unit;

  .FormArticleImage {
    margin-bottom: 1rem;
  }

  .sectionMeta {
    display: flex;
    flex-grow: 1;
    justify-content: space-between;
    margin-bottom: 1rem;

    .Field-cont {
      margin: 0;
      width: 100%;
    }
  }
}
</style>

<i18n>
{
  "en": {
    "positionExport": "Export position",
    "remove": "Remove",
    "text": "Text",
    "title": "Title",
    "suggest": "Suggest"
  }
}
</i18n>
